import { subjectId } from '../fixture-ids';

export const userLegacyAlternates = {};

export const userLegacyFixtures = {
  // No invitationId in legacy (current generation adds it).
  USER_INVITED: {
    action: 'USER_INVITED',
    debugData: { email: 'new.hire@example.com', roleName: 'Integration Manager' },
  },
  USER_DELETED: {
    action: 'USER_DELETED',
    debugData: { id: subjectId, email: 'former.employee@example.com', name: 'Former Employee' },
  },
  // No subjectId at all -- only the subject's email string (unresolvable-by-id,
  // degrades like PIPELINE_TAG_CREATED, no parentNameKeys declared -- `user` has no scoped view).
  USER_ROLE_EDITED: {
    action: 'USER_ROLE_EDITED',
    debugData: { email: 'teammate@example.com', oldRole: 'Editor', newRole: 'Admin' },
  },
  // A present string, not an absence -- must not be normalized to unknown or empty.
  USER_ROLE_EDITED_NO_PRIOR_ROLE: {
    action: 'USER_ROLE_EDITED',
    debugData: { email: 'brand.new@example.com', oldRole: 'no role', newRole: 'Read-Only' },
  },
};
